import Vue from 'vue';
import { getStarsHTML } from 'utils/general';
import select from 'dom-select';

export default {
  props: ['reviewsCount', 'reviewsAverage'],
  computed: {
    totalReviews() {
      return this.reviewsCount ? this.reviewsCount : 0;
    },
    reviewsText() {
      return this.totalReviews === 1
        ? '1 Review'
        : this.totalReviews + ' Reviews';
    },
    stars() {
      if (this.reviewsCount > 0) {
        return getStarsHTML(this.reviewsAverage);
      }
    },
    averageScoreText() {
      return `Average score of ${this.reviewsAverage} stars`;
    },
  },

  template: `
  <div v-if="totalReviews > 0" class="product-yotpo-review align-c">
    <section class="yotpo-area align-c">
      <div v-html="stars"></div>
      <p class="sr-only" v-text="averageScoreText"></p>
      <p class="h6">
        <span class="yotpo-stars__cta underline" v-text="reviewsText"></span>
      </p>
    </section>
  </div>`,
};
